import { useLayoutEffect, useState } from 'react'
import useResizeObserver from '@react-hook/resize-observer'

const useIsTruncated = target => {
  const [isTruncated, setIsTruncated] = useState()
  const isOverflowing = (scrollHeight, height) => scrollHeight > height

  useLayoutEffect(() => {
    if (target.current) {
      const contentRect = target.current.getBoundingClientRect()
      setIsTruncated(isOverflowing(Math.ceil(target.current.scrollHeight), Math.ceil(contentRect.height)))
    }
  }, [target])

  useResizeObserver(target, entry => {
    setIsTruncated(isOverflowing(Math.ceil(entry.target.scrollHeight), Math.ceil(entry.contentRect.height)))
  })
  return isTruncated
}

export default useIsTruncated
